export enum TcServiceTypeCategory {
  TC_SERVICE_UNDEFINED = 'not_defined',
  TC_SERVICE_ACCOUNT_KEEP_ALIVE = 'account_keepalive',
  TC_SERVICE_CPAAS_DEFAULT = 'cpaas_default',
  TC_SERVICE_CPAAS_BOBO_DEFAULT = 'cpaas_bobo_default',
  TC_SERVICE_DID_LIC = 'did_lic',
  TC_SERVICE_DID_SEAT = 'did_seat',
  TC_SERVICE_TELCO = 'telco',
  TC_SERVICE_PBX = 'pbx',
  TC_SERVICE_MONITOR = 'monitor',
  TC_SERVICE_ATA_PORT = 'ata_port',
  TC_SERVICE_SIM = 'sim_data_plan',
  TC_SERVICE_DIALER = 'dialer',
  TC_SERVICE_POWERCYCLE = 'power_cycle',
  TC_SERVICE_HAAS = 'haas',
  TC_SERVICE_ROUTER_STATUS = 'router_status',
  TC_SERVICE_ROUTER = 'router',
  TC_SERVICE_FIBER_CIRCUIT = 'fiber_circuit',
  TC_SERVICE_STARLINK_CIRCUIT = 'starlink_circuit',
}
